export const CHATBOT_ENABLE_LOCALES = ["en-US"];
